var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leaderboard-selector-control"},[_c('button',{staticClass:"arrow left",on:{"click":_vm.left}}),_c('div',{staticClass:"selection-label"},[_c('p',[_vm._v(_vm._s(_vm.leaderboard))])]),_c('button',{staticClass:"arrow right",on:{"click":_vm.right}})])
}
var staticRenderFns = []

export { render, staticRenderFns }